/**
 * Wraps text props with MondayMarkupLanguage component to enable markdown-style formatting.
 * Processes component props and automatically wraps string values marked as TEXT type
 * with the markup language parser for rich text rendering.
 */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { FIELD_TYPES } from "constants/template-field-type";
const containsMarkup = (text)=>/<[^>]+>/.test(text);
const shouldWrapTextProp = (propValue, propConfig)=>{
    return (propConfig === null || propConfig === void 0 ? void 0 : propConfig.type) === FIELD_TYPES.TEXT && propValue && typeof propValue === 'string' && containsMarkup(propValue);
};
const wrapTextValue = (textValue)=>{
    return /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
        text: textValue,
        tagName: "span"
    });
};
export const wrapTextPropsWithMarkup = (props, componentConfig)=>{
    if (!(componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.props)) {
        return props;
    }
    const wrappedProps = _object_spread({}, props);
    Object.entries(componentConfig.props).forEach(([propName, propConfig])=>{
        const propValue = props[propName];
        if (shouldWrapTextProp(propValue, propConfig)) {
            wrappedProps[propName] = wrapTextValue(propValue);
        }
    });
    return wrappedProps;
};
